// extracted by mini-css-extract-plugin
module.exports = {"projectImage":"ProjectImage-module--projectImage--1vNRr"};